export default "__VITE_ASSET__CwVZcmz1__"